<template>
    <Head title="Solicitar Integracion TiendaNube" />
    <div class="bg-gray-200 h-screen relative flex overflow-auto">
        <div class="absolute bg-primary-500 h-1/2 w-full top-0"></div>
            <div class="flex flex-col p-6 z-10 space-y-7 w-full items-center justify-center">
            <!-- logo + title -->
            <XyzTransition v-show="isImageLoaded" appear xyz="fade">
                <Link :href="route('dashboard')" class="flex space-x-3">
                    <img
                        src="@assets/images/shared/logo-shipro-light.svg"
                        class="scale-125"
                        alt="logo"
                    />
                    <span class="text-3xl text-white font-bold">Shipro</span>
                </Link>
            </XyzTransition>
            <!-- sign in card -->
            <XyzTransition v-show="isImageLoaded" appear xyz="fade">
                <div class="flex shadow-md min-w-full sm:min-w-[500px] lg:min-w-min">
                    <div class="flex flex-col justify-center w-full bg-white p-6 sm:p-8 lg:p-16 lg:w-[600px] rounded-lg">
                        <span class="text-center text-xl lg:text-2xl font-bold text-gray-900"
                            >Integración en TiendaNube</span>
                        <form class="flex flex-col mt-6 space-y-3">
                        <div class="flex flex-col w-full">
                            <div class="bg-white rounded-lg shadow p-5 m-2 lg:mx-4 lg:max-w-3xl">
                                <div class="flex gap-x-3">
                                    <div class="flex flex-col gap-y-3">
                                        <div class="flex flex-col">
                                        <label for="empresa" class="my-1 text-gray-500">
                                            Nombre de la Empresa<span class="text-red-400">*</span>
                                        </label>
                                        <input
                                            type="text"
                                            id="empresa"
                                            :class="[
                                                't-input',
                                                form.errors.empresa && 't-input-invalid',
                                            ]"
                                            v-model="form.empresa"
                                            required
                                            @focus="form.errors.empresa = null"
                                        />
                                        <small
                                            v-if="form.errors.empresa"
                                            id="empresa-help"
                                            class="p-error"
                                        >
                                            {{ form.errors.empresa }}
                                        </small>
                                        </div>
                                        <div class="flex flex-col">
                                            <label for="contacto" class="my-1 text-gray-500">
                                                Persona de Contacto<span class="text-red-400">*</span>
                                            </label>
                                            <input
                                                type="text"
                                                id="contacto"
                                                :class="[
                                                    't-input',
                                                    form.errors.contacto && 't-input-invalid',
                                                ]"
                                                v-model="form.contacto"
                                                required
                                                @focus="form.errors.contacto = null"
                                            />
                                            <small
                                                v-if="form.errors.contacto"
                                                id="contacto-help"
                                                class="p-error"
                                            >
                                                {{ form.errors.contacto }}
                                            </small>
                                        </div>
                                    </div>
                                    <div class="flex flex-col gap-y-3">
                                        <div class="flex flex-col">
                                        <label for="email" class="my-1 text-gray-500">
                                            Correo Electrónico<span class="text-red-400">*</span>
                                        </label>
                                        <input
                                            type="email"
                                            id="email"
                                            :class="[
                                                't-input',
                                                form.errors.email && 't-input-invalid',
                                            ]"
                                            v-model="form.email"
                                            required
                                            @focus="form.errors.email = null"
                                        />
                                        <small
                                            v-if="form.errors.email"
                                            id="email-help"
                                            class="p-error"
                                        >
                                            {{ form.errors.email }}
                                        </small>
                                        </div>
                                        <div class="flex flex-col">
                                            <label for="telefono" class="my-1 text-gray-500">
                                                Teléfono<span class="text-red-400">*</span>
                                            </label>
                                            <input
                                                type="tel"
                                                id="telefono"
                                                :class="[
                                                    't-input',
                                                    form.errors.telefono && 't-input-invalid',
                                                ]"
                                                v-model="form.telefono"
                                                required
                                                @focus="form.errors.telefono = null"
                                            />
                                            <small
                                                v-if="form.errors.telefono"
                                                id="telefono-help"
                                                class="p-error"
                                            >
                                                {{ form.errors.telefono }}
                                            </small>
                                        </div>
                                    </div>
                                </div> 
                            </div>
                        </div>
                        <div class="m-4 flex justify-center">
                            <Button @click.prevent="store" class="text-white bg-primary-500 hover:bg-primary-800 focus:ring-4 focus:ring-primary-300 font-medium rounded-lg text-sm w-full sm:w-auto px-5 py-2.5 text-center"> Solicitar </Button>
                        </div>
                    </form>
                    </div>
                </div>
            </XyzTransition>
        </div>
        <!-- footer -->
        <div class="absolute bottom-1 inset-x-0 text-center">
            <span class="text-[12px] text-gray-600">Copyright© 2018-2022</span>
        </div>
    </div>
</template>

<script>
import { Head, Link } from "@inertiajs/inertia-vue3";
import { TruckReturn, Variable } from "@vicons/tabler";
import Spinner from "../../shared/Spinner.vue";

export default {
    components: {
        Head,
        Link,
        Spinner,
    },
    props: {
        id_tiendanube: Variable,
        token_tiendanube: Variable,
        tiendanube: Array,
    },
    data() {
        return {
            isImageLoaded: true,
            form: this.$inertia.form({
                empresa: null,
                contacto: null,
                telefono: null,
                email: null,
                token_tiendanube: null,
                id_tiendanube: null,
            }),
        };
    },
    created() {
        this.form.id_tiendanube = this.id_tiendanube;
        this.form.token_tiendanube = this.token_tiendanube;
    },
    methods: {
        store() {
            console.log(this.form);
            this.form.post("/tiendanube");
        },
        imageLoaded() {
            this.isImageLoaded = true;
        },
    },
};
</script>